export const ExitFullscreen = ({ color = 'black' }) => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    data-qa="fullscreen_icon"
  >
    <g filter="url(#filter0_d)">
      <path d="M22.374 8L16.374 8L16.374 2" stroke={color} strokeWidth="1.5" />
      <path d="M4.37402 8L10.374 8L10.374 2" stroke={color} strokeWidth="1.5" />
      <path d="M22.374 14L16.374 14L16.374 20" stroke={color} strokeWidth="1.5" />
      <path d="M4.37402 14H10.374V20" stroke={color} strokeWidth="1.5" />
    </g>
    <defs>
      <filter
        id="filter0_d"
        x="0.374023"
        y="0"
        width="26"
        height="26"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1819 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
      </filter>
    </defs>
  </svg>
);
